// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4899":"01ad8bcf","9231":"4bd361f9"}[chunkId] + ".chunk.css";
};